import { Input } from "antd";

const TextInput = ({
  label,
  defaultValue,
  onChange,
  placeholder,
  suffix,
  handleEnter,
  value,
}) => {
  return (
    <div>
      <p>{label}</p>
      <Input
        value={value}
        suffix={suffix}
        type="text"
        className="form-control border-DCDCDC text-input"
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={onChange}
        onKeyDown={handleEnter && handleEnter("enter")}
        onBlur={handleEnter && handleEnter("blur")}
      />
    </div>
  );
};

export default TextInput;
